import { useEffect, useRef } from 'react';

/**
 * Reload the page when the person behind the session changes underneath it.
 *
 * The session cookie belongs to the browser, not to this tab, so staff starting
 * or stopping "Login as" in the console silently makes every other tab somebody
 * else. Queries refetch on focus, which is how this is noticed; what follows
 * has to be a full reload rather than a re-render, because the query cache, the
 * open chat socket and everything already on screen were built for whoever this
 * tab used to be.
 *
 * The first identity seen is not a change. Nothing happens until one is known.
 */
export function useReloadOnIdentityChange(identity: string | undefined): void {
  const seen = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (identity === undefined) {
      return;
    }

    if (seen.current === undefined) {
      seen.current = identity;
      return;
    }

    if (seen.current !== identity) {
      window.location.reload();
    }
  }, [identity]);
}
